"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  INFURA: 'INFURA',
  HTTP: 'HTTP',
  WEBSOCKET: 'WEBSOCKET',
  // a browser provider is one that comes from the browser, i.e. `window.web3`,
  // or from MetaMask's new "postMessage" method of requesting a provider.
  BROWSER: 'BROWSER',
  // A provider constructed outside this library and injected as-is
  INJECT: 'INJECT'
};
exports["default"] = _default;